require('./_set-species')('Array');



/*****************
 ** WEBPACK FOOTER
 ** /opt/yplan/npm_env_portal_2/~/babel-polyfill/~/core-js/modules/es6.array.species.js
 ** module id = 1853
 ** module chunks = 0
 **/